import Navbar from '../components/Navbar';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const SECTIONS = [
  {
    title: '1. The Service',
    content: [
      'CalcByEA ("the Service", "we", "us") is a satirical web application that parodies the microtransaction model popularised by video game publishers. It is a parody and is not affiliated with, endorsed by, or connected to Electronic Arts Inc. in any way.',
      '"EA" as used on this site is a reference to the cultural phenomenon of gaming microtransactions, not to Electronic Arts Inc. specifically. Electronic Arts™ is a trademark of Electronic Arts Inc.',
      'The Service provides a functional calculator. Certain calculator operations are locked behind purchasable "DLC packs" as part of the satirical premise. The packs are real; the outrage is yours to provide.',
    ],
  },
  {
    title: '2. Purchases & Payments',
    content: [
      'All purchases are processed securely by Stripe. By completing a purchase, you agree to Stripe\'s terms of service (stripe.com/legal).',
      'All sales are final. We do not offer refunds on purchased DLC packs. You unlocked the button. The button is unlocked. That\'s it.',
      'Prices are displayed in USD. We reserve the right to change prices at any time — just like EA does.',
      'You must be at least 18 years old (or have the permission of a guardian) to make a purchase.',
      'By purchasing, you acknowledge you are buying access to calculator functionality in a satirical application, not a financial product, investment, or physical good.',
    ],
  },
  {
    title: '3. Accounts',
    content: [
      'You sign in using your Google account via OAuth. You are responsible for maintaining the security of your Google account.',
      'Your purchased packs are tied to your Google account email address. If you lose access to your Google account, we cannot transfer your purchases.',
      'We reserve the right to suspend or terminate accounts that abuse the Service, attempt to circumvent payments, or violate these Terms.',
    ],
  },
  {
    title: '4. Intellectual Property',
    content: [
      'The design, code, and content of this website are the property of the operator of CalcByEA. You may not copy, reproduce, or redistribute any part of the Service without prior written permission.',
      'The satirical premise and commentary on microtransactions constitute protected parody/commentary speech.',
      '"Electronic Arts" and "EA" are trademarks of Electronic Arts Inc. This site is a parody and is not affiliated with or endorsed by Electronic Arts Inc.',
    ],
  },
  {
    title: '5. Disclaimers & Limitation of Liability',
    content: [
      'The Service is provided "as is" without warranties of any kind. We don\'t guarantee the Service will be available 100% of the time — we\'re a parody calculator, not a hospital.',
      'To the maximum extent permitted by law, we are not liable for any indirect, incidental, or consequential damages arising from your use of the Service.',
      'Our total liability for any claim arising from the Service is limited to the amount you paid us in the 30 days prior to the claim. Given our prices, that\'s probably $0.99.',
    ],
  },
  {
    title: '6. Governing Law',
    content: [
      'These Terms are governed by and construed in accordance with applicable law.',
      'Any disputes arising from these Terms or the Service shall be resolved through good-faith negotiation before any formal proceedings.',
    ],
  },
  {
    title: '7. Changes to These Terms',
    content: [
      'We may update these Terms at any time. Continued use of the Service after changes are posted constitutes acceptance of the new Terms.',
      'We will not charge you extra to read the updated Terms. Unlike some companies, we know where to draw the line.',
      'These Terms were last updated: May 2026.',
    ],
  },
  {
    title: '8. Contact',
    content: [
      'For any questions about these Terms, contact: admin@itorzo.com',
    ],
  },
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-zinc-50 text-zinc-950">
      <Navbar />
      <div className="pt-14">
        {/* Header */}
        <div className="border-b-2 border-zinc-950 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
            <Helmet>
              <title>Terms of Service | CalcByEA™</title>
              <meta name="description" content="CalcByEA terms of service. All sales final. This is a satirical calculator parody. Not affiliated with Electronic Arts." />
              <link rel="canonical" href="https://calculatorbyea.com/terms" />
              <meta property="og:url" content="https://calculatorbyea.com/terms" />
              <meta property="og:title" content="Terms of Service | CalcByEA™" />
              <meta property="og:description" content="CalcByEA terms of service. All sales final. This is a satirical calculator parody. Not affiliated with Electronic Arts." />
              <meta name="twitter:title" content="Terms of Service | CalcByEA™" />
              <meta name="twitter:description" content="All sales final. Satirical calculator parody. Not affiliated with Electronic Arts." />
            </Helmet>
            <div className="text-[10px] font-bold uppercase tracking-[0.35em] text-zinc-400 mb-4">Legal</div>
            <h1 className="font-bebas text-4xl sm:text-5xl text-zinc-950 mb-3">Terms of Service</h1>
            <p className="text-zinc-500 text-sm">
              By using this calculator, you agree to these terms. Or don't use the calculator. Zero is still free.
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <div className="space-y-10">
            {SECTIONS.map(({ title, content }) => (
              <div key={title}>
                <h2 className="font-bebas text-2xl text-zinc-950 mb-3 border-b border-zinc-200 pb-2">{title}</h2>
                <ul className="space-y-2">
                  {content.map((item, i) => (
                    <li key={i} className="flex gap-3 text-sm text-zinc-600 leading-relaxed">
                      <span className="text-zinc-300 font-bold shrink-0 mt-0.5">—</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t-2 border-zinc-200 flex gap-6 text-xs font-bold uppercase tracking-widest text-zinc-400">
            <Link to="/privacy" className="hover:text-zinc-950 transition-colors">Privacy Policy</Link>
            <Link to="/" className="hover:text-zinc-950 transition-colors">Back to Calculator</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
